import Vue from "vue"
import Router from "vue-router"
import module from "./module"
import Index from "@views/home/Index"
import Search from "@views/shop/GoodSearch"
import Category from "@views/shop/GoodsClass"
import ShoppingCart from "@views/shop/ShoppingCart"
import GoodsList from "@views/shop/GoodsList"
import NotDefined from "@views/NotDefined"
import $store from "../store"
import toLogin from "@libs/login"
import Loading from "@views/Loading"

Vue.use(Router)

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "Index",
      meta: {
        title: "首页",
        keepAlive: false,
        footer: true,
        backgroundColor: "#fff"
      },
      // component: Index
      component: () => import("@views/home/Index.vue")
    },
    {
      path: "/questionnaire",
      name: "questionnaire",
      meta: {
        title: "满意度调查",
        keepAlive: false,
        footer: false,
        backgroundColor: "#ffffff"
      },
      // component: Index
      component: () => import("@views/questionnaire/questionnaire.vue")
    },
    {
      path: "/shareActivity",
      name: "shareActivity",
      meta: {
        title: "详情",
        keepAlive: false,
        footer: false,
        backgroundColor: "#ffffff"
      },
      component: () => import("@views/shareActivity/index.vue")
    },
    {
      path: "/mianzheng",
      name: "mianzheng",
      meta: {
        title: "我的面整",
        keepAlive: false,
        footer: false,
        backgroundColor: "#530087"
      },
      // component: Index
      component: () => import("@views/mianzheng/index.vue")
    },
    {
      path: "/mianzheng/list",
      name: "mianzheng_list",
      meta: {
        title: "我的面整",
        keepAlive: false,
        footer: false,
        backgroundColor: "#ffffff"
      },
      // component: Index
      component: () => import("@views/mianzheng/list.vue")
    },
    {
      path: "/mianzheng/list/list_item",
      name: "mianzheng_list_item",
      meta: {
        title: "我的面诊",
        keepAlive: false,
        footer: false,
        backgroundColor: "#530087"
      },
      // component: Index
      component: () => import("@views/mianzheng/list_item.vue")
    },
    {
      path: "/mianzheng/list/list_item1",
      name: "mianzheng_list_item1",
      meta: {
        title: "我的面整",
        keepAlive: false,
        footer: false,
        backgroundColor: "#530087"
      },
      // component: Index
      component: () => import("@views/mianzheng/list_item1.vue")
    },
    {
      path: "/mianzheng/info",
      name: "mianzheng_info",
      meta: {
        title: "我的面诊",
        keepAlive: false,
        footer: false,
        backgroundColor: "#530087"
      },
      // component: Index
      component: () => import("@views/mianzheng/info.vue")
    },
    {
      path: "/mianzheng/subinfo",
      name: "mianzheng_subinfo",
      meta: {
        title: "我的面诊-确认",
        keepAlive: false,
        footer: false,
        backgroundColor: "#490a94"
      },
      // component: Index
      component: () => import("@views/mianzheng/subinfo.vue")
    },
    {
      path: "/mianzheng/mingxi",
      name: "mianzheng_mingxi",
      meta: {
        title: "我的面诊记录",
        keepAlive: false,
        footer: false,
        backgroundColor: "#FFFFFF"
      },
      // component: Index
      component: () => import("@views/mianzheng/mingxiList.vue")
    },
    {
      path: "/mianzheng/yindao",
      name: "mianzheng_yindao",
      meta: {
        title: "个人信息",
        keepAlive: false,
        footer: false,
        backgroundColor: "#f5f5f5"
      },
      // component: Index
      component: () => import("@views/mianzheng/yindao.vue")
    },
    {
      path: "/jiaodian/brand/addBrand",
      name: "AddBrand",
      meta: {
        title: "添加品牌行业",
        keepAlive: false,
        footer: false,
        backgroundColor: "#ffffff"
      },
      component: () => import("@views/jiaodian/brand/addBrand.vue")
    },
    {
      path: "/jiaodian/brand/",
      name: "Index",
      meta: {
        title: "添加品牌行业",
        keepAlive: false,
        footer: false,
        backgroundColor: "#ffffff"
      },
      component: () => import("@views/jiaodian/brand/Index.vue")
    },
    {
      path: "/jiaodian/search",
      name: "Search",
      meta: {
        title: "搜索文章/视频/品牌",
        keepAlive: false,
        footer: false,
        backgroundColor: "#fff"
      },
      component: () => import("@views/jiaodian/search/searchIndex.vue")
    },
    {
      path: "/jiaodian/addarticle",
      name: "AddArticle",
      meta: {
        title: "添加文章/视频",
        keepAlive: false,
        footer: false,
        backgroundColor: "#f5f5f5"
      },
      component: () => import("@views/jiaodian/article/addArticle.vue")
    },
    {
      path: "/jiaodian/userWeizhan",
      name: "Index",
      meta: {
        title: "我的微站",
        keepAlive: false,
        footer: false,
        backgroundColor: "#fff"
      },
      component: () => import("@views/jiaodian/userWeizhan/Index.vue")
    },
    {
      path: "/jiaodian/userWeizhan_zixun",
      name: "Index",
      meta: {
        title: "我的资讯",
        keepAlive: true,
        footer: false,
        backgroundColor: "#fff"
      },
      component: () => import("@views/jiaodian/userWeizhan/zixunIndex.vue")
    },
    {
      path: "/jiaodian/imgtextDetail",
      name: "Index",
      meta: {
        title: "图文详情",
        keepAlive: false,
        footer: false,
        backgroundColor: "#fff"
      },
      component: () => import("@views/jiaodian/imgtextDetail/Index.vue")
    },
    {
      path: "/jiaodian/editDetail",
      name: "edit",
      meta: {
        title: "图文详情编辑",
        keepAlive: false,
        footer: false,
        backgroundColor: "#fff"
      },
      component: () => import("@views/jiaodian/imgtextDetail/editDetail.vue")
    },
    {
      path: "/jiaodian/insertion",
      name: "Insertion",
      meta: {
        title: "插入广告",
        keepAlive: false,
        footer: false,
        backgroundColor: "#f5f5f5"
      },
      component: () => import("@views/jiaodian/imgtextDetail/insertion.vue")
    },
    {
      path: "/my",
      name: "My",
      meta: {
        title: "个人中心",
        keepAlive: false,
        footer: true,
        backgroundColor: "#fff"
      },
      component: () => import("@views/my/my.vue")
    },
    {
      path: "/my/card",
      name: "MyCard",
      meta: {
        title: "我",
        keepAlive: false,
        footer: false,
        backgroundColor: "#f5f5f5"
      },
      component: () => import("@views/my/myCard.vue")
    },
    {
      path: "/my/code_list",
      name: "MyCodeList",
      meta: {
        title: "咨询师列表",
        keepAlive: false,
        footer: false,
        backgroundColor: "#f5f5f5"
      },
      component: () => import("@views/my/codeList.vue")
    },
    {
      path: "/member",
      name: "Member",
      meta: {
        title: "开通超级会员",
        keepAlive: false,
        footer: false,
        backgroundColor: "#f5f5f5"
      },
      component: () => import("@views/my/member.vue")
    },
    {
      path: "/memberInfo",
      name: "MemberInfo",
      meta: {
        title: "会员详情介绍",
        keepAlive: false,
        footer: false,
        backgroundColor: "#f5f5f5"
      },
      component: () => import("@views/my/memberInfo.vue")
    },
    {
      path: "/my/card/changeName",
      name: "ChangeName",
      meta: {
        title: "编辑姓名信息",
        keepAlive: false,
        footer: false,
        backgroundColor: "#f5f5f5"
      },
      component: () => import("@views/my/changeName.vue")
    },
    {
      path: "/my/card/changeTel",
      name: "ChangeTel",
      meta: {
        title: "编辑手机号码信息",
        keepAlive: false,
        footer: false,
        backgroundColor: "#f5f5f5"
      },
      component: () => import("@views/my/changeTel.vue")
    },
    {
      path: "/my/card/changeSign",
      name: "ChangeSign",
      meta: {
        title: "编辑签名信息",
        keepAlive: false,
        footer: false,
        backgroundColor: "#f5f5f5"
      },
      component: () => import("@views/my/changeSign.vue")
    },
    {
      path: "/project/list",
      name: "projectList",
      meta: {
        title: "招商项目",
        keepAlive: false,
        footer: false,
        backgroundColor: "#f5f5f5"
      },
      component: () => import("@views/jiaodian/project/projectList.vue")
    },
    {
      path: "/project/index",
      name: "addproject",
      meta: {
        title: "发布招商项目",
        keepAlive: false,
        footer: false,
        backgroundColor: "#f5f5f5"
      },
      component: () => import("@views/jiaodian/project/addproject.vue")
    },
    {
      path: "/project/info",
      name: "projectInfo",
      meta: {
        title: "项目详情",
        keepAlive: false,
        footer: false,
        backgroundColor: "#f5f5f5"
      },
      component: () => import("@views/jiaodian/project/projectInfo.vue")
    },
    {
      path: "/my/collect",
      name: "MyCollect",
      meta: {
        title: "我的收藏",
        keepAlive: false,
        footer: false,
        backgroundColor: "#f5f5f5"
      },
      component: () => import("@views/my/myCollect.vue")
    },
    {
      path: "/my/team",
      name: "MyTeam",
      meta: {
        title: "我的团队",
        keepAlive: false,
        footer: false,
        backgroundColor: "#f5f5f5"
      },
      component: () => import("@views/my/myTeam.vue")
    },
    {
      path: "/my/team/list",
      name: "MyTeamList",
      meta: {
        title: "切换团队",
        keepAlive: false,
        footer: false,
        backgroundColor: "#f5f5f5"
      },
      component: () => import("@views/my/myTeamList.vue")
    },
    {
      path: "/my/team/invite",
      name: "MyTeamInvite",
      meta: {
        title: "邀请加入",
        keepAlive: false,
        footer: false,
        backgroundColor: "#ffffff"
      },
      component: () => import("@views/my/myTeamInvite.vue")
    },
    {
      path: "/my/team/changeName",
      name: "MyTeamChangeName",
      meta: {
        title: "修改团队名称",
        keepAlive: false,
        footer: false,
        backgroundColor: "#f5f5f5"
      },
      component: () => import("@views/my/changeTeamName.vue")
    },
    {
      path: "/my/team/deleteMember",
      name: "MyTeamDeleteMember",
      meta: {
        title: "删除团队成员",
        keepAlive: false,
        footer: false,
        backgroundColor: "#f5f5f5"
      },
      component: () => import("@views/my/deleteMember.vue")
    },
    {
      path: "/my/team/setAdmin",
      name: "MyTeamSetAdmin",
      meta: {
        title: "设置管理员",
        keepAlive: false,
        footer: false,
        backgroundColor: "#f5f5f5"
      },
      component: () => import("@views/my/setAdmin.vue")
    },
    {
      path: "/my/team/setCounselor",
      name: "MyTeamSetCounselor",
      meta: {
        title: "设置咨询师",
        keepAlive: false,
        footer: false,
        backgroundColor: "#f5f5f5"
      },
      component: () => import("@views/my/setCounselor.vue")
    },
    {
      path: "/my/issue",
      name: "MyIssue",
      meta: {
        title: "我的发布",
        keepAlive: false,
        footer: false,
        backgroundColor: "#f5f5f5"
      },
      component: () => import("@views/my/myIssue.vue")
    },
    {
      path: "/my/privacy",
      name: "MyPrivacy",
      meta: {
        title: "隐私声明",
        keepAlive: false,
        footer: false,
        backgroundColor: "#ffffff"
      },
      component: () => import("@views/my/myprivacy.vue")
    },
    {
      path: "/my/promotion",
      name: "MyPromotion",
      meta: {
        title: "推广赚钱",
        keepAlive: false,
        footer: false,
        backgroundColor: "#f5f5f5"
      },
      component: () => import("@views/my/promotion.vue")
    },
    {
      path: "/my/guide",
      name: "MyGuide",
      meta: {
        title: "使用指南",
        keepAlive: false,
        footer: false,
        backgroundColor: "#f5f5f5"
      },
      component: () => import("@views/my/userGuide.vue")
    },
    {
      path: "/kehu/index",
      name: "kehuList",
      meta: {
        title: "客户",
        keepAlive: false,
        footer: true,
        backgroundColor: "#ffffff"
      },
      component: () => import("@views/jiaodian/kehu/Index.vue")
    },
    {
      path: "/square",
      name: "Square",
      meta: {
        title: "人脉广场",
        keepAlive: false,
        footer: false,
        backgroundColor: "#f5f5f5"
      },
      component: () => import("@views/jiaodian/square/square.vue")
    },
    {
      path: "/kehu/kehuinfo",
      name: "kehuInfo",
      meta: {
        title: "客户详情",
        keepAlive: false,
        footer: false,
        backgroundColor: "#ffffff"
      },
      component: () => import("@views/jiaodian/kehu/kehuInfo.vue")
    },
    {
      path: "/kehu/setMessageReminder",
      name: "setMessageReminder",
      meta: {
        title: "谁看我消息提醒设置",
        keepAlive: false,
        footer: false,
        backgroundColor: "#ffffff"
      },
      component: () => import("@views/jiaodian/kehu/setMessageReminder.vue")
    },
    {
      path: "/video/index",
      name: "videindex",
      meta: {
        title: "视频",
        keepAlive: false,
        footer: false,
        backgroundColor: "#ffffff"
      },
      component: () => import("@views/jiaodian/video/Index.vue")
    },
    {
      path: "/video/shareindex",
      name: "videshareindex",
      meta: {
        title: "视频",
        keepAlive: false,
        footer: false,
        backgroundColor: "#ffffff"
      },
      component: () => import("@views/jiaodian/video/sharevIndex.vue")
    },
    {
      path: "/guanggao/index",
      name: "guanggaoAdd",
      meta: {
        title: "编辑添加广告",
        keepAlive: false,
        footer: false,
        backgroundColor: "#f5f5f5"
      },
      component: () => import("@views/jiaodian/guanggao/addGuangGao.vue")
    },
    {
      path: "/guanggao/add",
      name: "advertisngList",
      meta: {
        title: "编辑添加广告",
        keepAlive: false,
        footer: false,
        backgroundColor: "#f5f5f5"
      },
      component: () => import("@views/jiaodian/guanggao/addAdvertisng.vue")
    },
    {
      path: "/my/issue/look",
      name: "MyIssueLook",
      meta: {
        title: "查看文章客户",
        keepAlive: false,
        footer: false,
        backgroundColor: "#ffffff"
      },
      component: () => import("@views/my/myIssueLook.vue")
    },
    {
      path: "/clock",
      name: "Clock",
      meta: {
        title: "打卡",
        keepAlive: false,
        footer: false,
        backgroundColor: "#f5f5f5"
      },
      component: () => import("@views/jiaodian/clock/clock.vue")
    },
    {
      path: "/customer/chat/:id/:productId?",
      name: "CustomerService",
      meta: {
        title: "客服聊天",
        keepAlive: false,
        auth: true
      },
      component: () => import("@views/user/CustomerService.vue")
    },
    {
      path: "/category/:pid?",
      name: "GoodsClass",
      meta: {
        title: "产品分类",
        keepAlive: true,
        footer: true,
        backgroundColor: "#fff"
      },
      component: Category
    },
    {
      path: "/collection",
      name: "GoodsCollection",
      meta: {
        title: "收藏商品",
        keepAlive: false,
        auth: true
      },
      component: () => import("@views/shop/GoodsCollection.vue")
    },
    {
      path: "/search",
      name: "GoodSearch",
      meta: {
        title: "搜索商品",
        keepAlive: true,
        backgroundColor: "#fff"
      },
      component: Search
    },
    {
      path: "/news_detail/:id",
      name: "NewsDetail",
      meta: {
        title: "新闻详情",
        keepAlive: true,
        backgroundColor: "#fff"
      },
      component: () => import("@views/shop/news/NewsDetail.vue")
    },
    {
      path: "/news_list",
      name: "NewsList",
      meta: {
        title: "新闻",
        keepAlive: true,
        backgroundColor: "#fff"
      },
      component: () => import("@views/shop/news/NewsList.vue")
    },
    {
      path: "/evaluate_list/:id",
      name: "EvaluateList",
      meta: {
        title: "商品评分",
        keepAlive: true,
        auth: true
      },
      component: () => import("@views/shop/EvaluateList.vue")
    },
    {
      path: "/goods_evaluate/:id",
      name: "GoodsEvaluate",
      meta: {
        title: "商品评价",
        keepAlive: true,
        auth: true
      },
      component: () => import("@views/shop/GoodsEvaluate.vue")
    },
    {
      path: "/promotion",
      name: "GoodsPromotion",
      meta: {
        title: "促销单品",
        keepAlive: false
      },
      component: () => import("@views/shop/GoodsPromotion.vue")
    },
    {
      path: "/hot_new_goods/:type",
      name: "HotNewGoods",
      meta: {
        title: "热门榜单",
        keepAlive: false
      },
      component: () => import("@views/shop/HotNewGoods.vue")
    },
    {
      path: "/detail/:id",
      name: "GoodsCon",
      meta: {
        title: "商品详情",
        keepAlive: false
      },
      component: () => import("@views/shop/GoodsCon.vue")
    },
    {
      path: "/shop/storeList/:gonames?",
      name: "StoreList",
      meta: {
        title: "门店列表",
        keepAlive: false
      },
      component: () => import("@views/shop/StoreList.vue")
    },
    {
      path: "/cart",
      name: "ShoppingCart",
      meta: {
        title: "购物车",
        keepAlive: true,
        footer: true,
        auth: true
      },
      component: ShoppingCart
    },
    {
      path: "/goods_list",
      name: "GoodsList",
      meta: {
        title: "商品列表",
        keepAlive: true
      },
      component: GoodsList
    },
    {
      path: "/register",
      name: "Register",
      meta: {
        title: "注册",
        keepAlive: true
      },
      component: () =>
        import(/* webpackChunkName: "login" */ "@views/user/Register.vue")
    },
    {
      path: "/change_password",
      name: "ChangePassword",
      meta: {
        title: "修改密码",
        keepAlive: true,
        backgroundColor: "#fff",
        auth: true
      },
      component: () =>
        import(/* webpackChunkName: "login" */ "@views/user/ChangePassword.vue")
    },
    {
      path: "/retrieve_password",
      name: "RetrievePassword",
      meta: {
        title: "找回密码",
        keepAlive: true
      },
      component: () =>
        import(/* webpackChunkName: "login" */ "@views/user/RetrievePassword.vue")
    },
    {
      path: "/login",
      name: "Login",
      meta: {
        title: "登录",
        keepAlive: true
      },
      component: () =>
        import(/* webpackChunkName: "login" */ "@views/user/Login.vue")
    },
    ...module,
    {
      path: "/auth/:url",
      name: "Loading",
      meta: {
        title: " 加载中",
        keepAlive: true
      },
      component: Loading
    },
    {
      path: "*",
      name: "NotDefined",
      meta: {
        title: "页面找不到",
        keepAlive: true,
        home: false,
        backgroundColor: "#F4F6FB"
      },
      component: NotDefined
    }
  ],
  scrollBehavior (to, from) {
    from.meta.scrollTop = window.scrollY
    return { x: 0, y: to.meta.scrollTop || 0 }
  }
})

const { back, replace } = router

router.back = function () {
  this.isBack = true
  back.call(router)
}
router.replace = function (...args) {
  this.isReplace = true
  replace.call(router, ...args)
}

router.beforeEach((to, form, next) => {
  const { title, backgroundColor, footer, home, auth } = to.meta
  console.log(to.name, form.name)
  if (auth === true && !$store.state.app.token) {
    if (form.name === "Login") return
    return toLogin(true, to.fullPath)
  }
  document.title = title || process.env.VUE_APP_NAME || "crmeb商城"
  //判断是否显示底部导航
  footer === true ? $store.commit("SHOW_FOOTER") : $store.commit("HIDE_FOOTER")

  //控制悬浮按钮是否显示
  home === false ? $store.commit("HIDE_HOME") : $store.commit("SHOW_HOME")

  $store.commit("BACKGROUND_COLOR", backgroundColor || "#F5F5F5")

  if (auth) {
    $store.dispatch("USERINFO").then(() => {
      next()
    })
  } else next()
})

export default router
